import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';

interface DraggableProps {
  className?: string;
  enabled?: boolean;
  value?: string;
  onClick?: () => void;
  onTouch?: () => void;
}

export const Draggable = ({
  children,
  className,
  enabled = true,
  value,
  onClick,
  onTouch,
}: React.PropsWithChildren<DraggableProps>) => {
  const draggableElementRef = useRef<HTMLButtonElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (!draggableElementRef?.current) {
      return;
    }

    const letterElement = draggableElementRef.current;

    const handleDragStart = (event: DragEvent) => {
      setIsDragging(true);

      if (value) {
        event.dataTransfer?.setData('text/plain', value);
      } else {
        event.dataTransfer?.setData('text/html', letterElement.innerHTML);
      }
    };

    const handleDragEnd = () => {
      setIsDragging(false);
    };

    letterElement.addEventListener('dragstart', handleDragStart);
    letterElement.addEventListener('dragend', handleDragEnd);

    return () => {
      letterElement.removeEventListener('dragstart', handleDragStart);
      letterElement.removeEventListener('dragend', handleDragEnd);
    };
  }, []);

  return (
    <button
      ref={draggableElementRef}
      className={clsx(
        'flex items-center justify-center',
        isDragging && 'opacity-20',
        className,
      )}
      style={{
        touchAction: 'none',
      }}
      aria-label={enabled ? `Drag` : undefined}
      draggable={enabled}
      onClick={onClick}
      onTouchEnd={onTouch}
    >
      {children}
    </button>
  );
};
